import React from 'react';
import Reflux from 'reflux';
import { Form, Button, Menu, message, Input, Modal, Row, Col } from 'antd';
import { checkPhone } from '../../utils/regexp';
import { getModifyPhoneCode } from '../../service/home';
import { openNotice } from 'Utils';
const FormItem = Form.Item;

class EditBindingTel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCountdown: false,
      countdown: 59
    };
    this.getVerifyCode = this.getVerifyCode.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    this.timer && clearInterval(this.timer);
  }

  handleOk() {
    this.props.form.validateFields((err, value)=> {
      const { newTel, verifyCode }=err;
      if (!newTel && !verifyCode) {
        this.props.handleOk({
          newTel: value.newTel,
          verifyCode: value.verifyCode
        });
      }
    });
  }

  handleCancel() {
    this.props.form.setFieldsValue({
      newTel: '',
      verifyCode: ''
    });
    this.props.handleCancel();
  }

  getVerifyCode() {
    var self = this;
    this.props.form.validateFields((err, value)=> {
            getModifyPhoneCode({
              // mobile: this.props.phone
              mobile: value.newTel
            }).then(result=> {
              if (result && result.code == 200) {} else {
                openNotice('error', '获取验证码失败', (result && result.message) ? result.message : '');
              }
            });
            this.setState({
              showCountdown: true
            });
            this.timer = setInterval(function () {
              var cd = self.state.countdown;
              if (cd < 1) {
                clearInterval(self.timer);
                self.setState({
                  showCountdown: false,
                  countdown: 59
                });
              } else {
                self.setState({
                  countdown: cd - 1
                });
              }
            }, 1000);
    })
  }

  render() {
    const ModalItemLayout = {
      labelCol: {
        span: 7
      },
      wrapperCol: {
        span: 13
      }
    };

    const scd = this.state.showCountdown;
    return (

      <Modal
        title="修改绑定手机"
        wrapClassName="vertical-center-modal"
        visible={this.props.visible}
        onOk={(e)=> {this.handleOk(e)}}
        onCancel={(e)=> {this.handleCancel(e)}}
        cancelText='返回'
      >
        <Form layout="horizontal">
          <FormItem {...ModalItemLayout} label="绑定的手机号">
            <label>{this.props.phone}</label>
          </FormItem>
          <FormItem {...ModalItemLayout} label="请输入新手机号">
            {this.props.form.getFieldDecorator('newTel', {
              rules: [{
                required: true,
                message: '请输入新手机号'
              }, {
                validator: checkPhone
              }]
            })(
              <Input placeholder="请输入新手机号" />
            )}
          </FormItem>
          <FormItem {...ModalItemLayout} label="请输入验证码">
            {this.props.form.getFieldDecorator('verifyCode', {
              rules: [{
                required: true,
                message: '请输入验证码'
              }]
            })(
              <span>
									<Input placeholder="请输入验证码" style={{ width: 112 }} maxLength="6" />
									<Button style={{ marginLeft: 30 }} disabled={scd}
                          onClick={this.getVerifyCode}>{scd ? this.state.countdown + '秒后重试' : '发送验证码'}</Button>
									</span>
            )}
          </FormItem>
          <p>Tips：系统将向您的新号码发送验证码。如果原号码已停用，请联系管理员为您更改号码。</p>
        </Form>
      </Modal>

    );
  }
}
;
export default EditBindingTel;


// WEBPACK FOOTER //
// ./src/routes/profile/editBindingTel.js